import { Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { OnAttach, OnDetach } from '@app/modules/core/directives/app-router-outlet';
import { MobileDeviceService } from '@app/services/mobile-device.service';

@Component({
  selector: 'app-bus-results',
  templateUrl: './bus-results.container.html',
  styleUrls: ['./bus-results.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BusResultsContainer implements OnAttach, OnDetach {

  public disableScroll: boolean;

  constructor(
    private mobileDeviceService: MobileDeviceService,
    private changeDetectorRef: ChangeDetectorRef) { }

  onAttach(activatedRoute: ActivatedRoute): void {
    this.disableScroll = false;
  }

  onDetach(): void {
    this.disableScroll = true;
    this.changeDetectorRef.detectChanges();
  }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }
}
